import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useSelector } from 'react-redux'

const MobileHeaderSkeleton = () => {
  const { activeChatTheme } = useSelector((state) => state.theme)
  const isDark = activeChatTheme !== 'theme5'

  return (
    <div
      className={`header pl-14 flex items-center justify-between left-0 top-[33px] z-[998] pt-[3px] pb-1.5 w-full h-[56px] px-6 capitalize ${
        isDark ? '!bg-black' : 'bg-white'
      }`}
    >
      {/* Left side - Search icon skeleton */}
      <div className="flex gap-3 justify-start header-left relative w-1/3">
        <div className="w-10 h-10 flex items-center justify-center">
          <div className={`w-5 h-5 rounded animate-pulse ${isDark ? 'bg-white/20' : 'bg-gray-300'}`}></div>
        </div>
      </div>

      {/* Center - Logo */}
      <div className="items-center gap-3 w-1/3 justify-center inline-flex">
        <Link className="text-center text-sm font-semibold tracking-[0.14px]" href="/">
          <div className="logo inline-flex h-[32px] justify-center items-center shrink-0">
            <Image
              src="/assets/common/StyleyLogo.png"
              alt="Styley Logo"
              width={90}
              height={30}
              priority
              className={`h-[30px] w-auto object-contain ${isDark ? '!invert' : ''}`}
            />
          </div>
        </Link>
      </div>

      {/* Right side - Menu skeleton */}
      <div className="items-center w-1/3 justify-end flex">
        <div className="w-10 h-10 flex items-center justify-center">
          <div className={`w-9 h-9 rounded-full animate-pulse ${isDark ? 'bg-white/20' : 'bg-gray-300'}`}></div>
        </div>
      </div>
    </div>
  )
}

export default MobileHeaderSkeleton
